import * as React from "react";
import { Modal } from "components/modal";

interface PickUpWhereLeftOffModalProps {
  show: boolean;
  /** The role/intent the visitor typed on the landing page, previewed back to them. */
  role?: string | null;
  /** Auto-select the "hire for a role" flow and prefill the role input. */
  onContinue: () => void;
  /** Discard the carried-over intent and start fresh. */
  onStartNew: () => void;
}

const PickUpWhereLeftOffModal: React.FC<PickUpWhereLeftOffModalProps> = ({
  show,
  role,
  onContinue,
  onStartNew,
}) => {
  return (
    <Modal
      show={show}
      position="centered"
      close={onStartNew}
      contentClassName="!max-w-[640px] !w-[92vw] !p-0 !overflow-visible"
    >
      <div className="relative px-6 py-10 sm:px-12 sm:py-12 text-center">
        <button
          type="button"
          onClick={onStartNew}
          aria-label="Close"
          className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full border border-[#012169] text-[#012169] transition-colors hover:bg-[#012169] hover:text-white"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
            <path
              d="M1 1l12 12M13 1L1 13"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="mb-6 text-6xl" aria-hidden>
          💬
        </div>

        <h2 className="mb-3 text-3xl font-bold text-[#012169] sm:text-4xl">
          Pick Up Where You Left Off
        </h2>
        <p className="mx-auto mb-2 max-w-[440px] text-base text-[#667085] sm:text-lg">
          Would you like to continue with your previous request or start a new
          conversation?
        </p>
        {role && (
          <p className="mx-auto mb-8 max-w-[440px] truncate text-sm font-medium text-[#012169]">
            “{role}”
          </p>
        )}
        {!role && <div className="mb-8" />}

        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
          <button
            type="button"
            onClick={onStartNew}
            className="w-full rounded-lg border-[1.5px] border-[#012169] px-6 py-3.5 text-base font-semibold text-[#012169] transition-colors hover:bg-[#EFF4FA]"
          >
            Start New Chat
          </button>
          <button
            type="button"
            onClick={onContinue}
            className="w-full rounded-lg bg-[#012169] px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-[#011550]"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { PickUpWhereLeftOffModal };
